import { useAppStore } from '../hooks/useAppStore';
import { User, Shield, Hash, Calendar, Settings, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
  const { user, completedCount, topics, partners } = useAppStore();
  const nav = useNavigate();
  return (
    <div className="px-4 py-5 pb-8 space-y-4 animate-fade-in">
      <div className="glass p-6 text-center">
        <div className="w-16 h-16 rounded-full bg-burner-500/10 border border-burner-500/20 flex items-center justify-center mx-auto mb-3">
          <User size={28} className="text-burner-400" />
        </div>
        <h2 className="text-lg font-bold text-gray-100">{user.displayName}</h2>
        <p className="text-xs text-gray-500 font-mono mt-1">{user.profileId}</p>
      </div>
      <div className="glass p-4 space-y-4">
        <Stat icon={<Hash size={16}/>} label="Topics Completed" value={`${completedCount} / ${topics.length}`} />
        <Stat icon={<User size={16}/>} label="Partners" value={`${partners.length}`} />
        <Stat icon={<Shield size={16}/>} label="SIGPRINT Format" value="20-char (14+6)" />
        <Stat icon={<Calendar size={16}/>} label="Member Since" value="Today" />
        <Stat icon={<Settings size={16}/>} label="Encoding Version" value="v1.0" />
      </div>
      <div className="glass p-4"><p className="text-xs text-gray-500 leading-relaxed">All data stored locally on device. SIGPRINTs are generated fresh per partner link using the SIGPRINT v1.1 spec: 14 data dimensions + 6-char Fletcher-32 checksum.</p></div>
      <button onClick={()=>nav('/')} className="btn-ghost w-full"><LogOut size={16}/>Back to Home</button>
    </div>
  );
}

function Stat({icon,label,value}) {
  return (<div className="flex items-center justify-between"><div className="flex items-center gap-3 text-gray-400"><span className="text-burner-400">{icon}</span><span className="text-sm">{label}</span></div><span className="text-sm font-medium text-gray-200">{value}</span></div>);
}
